var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['message-text-container', _vm.isPC && 'text-select']
  }, _vm._l(_vm.textMessageData.text, function (item, index) {
    return _c('span', {
      key: index
    }, [item.name === 'text' && _vm.enableURLDetection === 1 ? _c('span', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }) : item.name === 'text' ? _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]) : _c('img', {
      staticClass: "emoji",
      attrs: {
        "src": item.src,
        "alt": item.emojiKey
      }
    })]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }